import { getApiBaseUrl } from 'src/api/config/apiBaseUrl';
import { createCsrfAwareAxiosInstance } from 'src/api/common/http/createCsrfAwareAxiosInstance';
import { attachBearerToken } from 'src/auth/authApi';

const erisAxiosInstance = createCsrfAwareAxiosInstance(getApiBaseUrl(), '/api/er/csrf');
erisAxiosInstance.interceptors.request.use(attachBearerToken);

export default erisAxiosInstance;
